import { ExpressedOutcomeEnum, toBigWithDefault } from '@talos/kyoko';
import type Big from 'big.js';
import type { BigSource } from 'big.js';

/** Positive = Yes contracts, negative = No contracts, zero has no side label. */
export function getPredictionPositionSideLabel(amount: BigSource): 'Yes' | 'No' | undefined {
  const big = toBigWithDefault(amount, 0);
  if (big.gt(0)) {
    return 'Yes';
  }
  if (big.lt(0)) {
    return 'No';
  }
  return undefined;
}

/**
 * When the selected Yes/No outcome is the opposite of an open position, the order reduces exposure.
 * Returns the copy shown under the Yes/No toggle, or undefined when there is nothing to offset.
 */
export function getPredictionPositionOffsetMessage(
  predictionOutcome: ExpressedOutcomeEnum | undefined,
  positionAmount: Big | undefined
): string | undefined {
  if (predictionOutcome == null || positionAmount == null || positionAmount.eq(0)) {
    return undefined;
  }
  const positionSide = getPredictionPositionSideLabel(positionAmount);
  if (positionSide === 'Yes' && predictionOutcome === ExpressedOutcomeEnum.No) {
    return 'Buying No "offsets" your Yes position, returning funds & reducing your exposure.';
  }
  if (positionSide === 'No' && predictionOutcome === ExpressedOutcomeEnum.Yes) {
    return 'Buying Yes "offsets" your No position, returning funds & reducing your exposure.';
  }
  return undefined;
}
